import React from 'react';
import logo from '../../assets/logo.svg';
export default () => {
  return <img src={logo} width={150} height={50} />
}